const escape = require("escape-html");
const moment = require("./moment");
const trans = require("./trans");

const placeholders = {
  "quote.description": ["{{presupuesto_descripcion}}", "{{quote_description}}"],
  "quote.code": ["{{presupuesto_codigo}}", "{{quote_code}}"],
  "quote.date": ["{{presupuesto_fecha}}", "{{quote_date}}"],
  "quote.expirationDate": ["{{presupuesto_fecha_validez}}", "{{quote_expiration_date}}"],
  "quote.version.number": ["{{presupuesto_version}}", "{{quote_version}}"],
  "organization.name": ["{{organizacion_nombre}}", "{{business_name}}", "{{organization_name}}"],
  "organization.addressLine1": ["{{organizacion_direccion}}", "{{business_address}}", "{{organization_address}}"],
  "organization.addressLine2": ["{{organizacion_direccion_2}}", "{{business_address_2}}", "{{organization_address_2}}"],
  "organization.stateOrProvince": [
    "{{organizacion_provincia}}",
    "{{business_state}}",
    "{{organization_state_province}}",
  ],
  "organization.city": [
    "{{organizacion_ciudad}}",
    "{{organizacion_poblacion}}",
    "{{business_city}}",
    "{{organization_city}}",
  ],
  "organization.country": ["{{organizacion_pais}}", "{{business_country}}", "{{organization_country}}"],
  "organization.zipOrPostalCode": ["{{organizacion_cp}}", "{{business_zip}}", "{{organization_zip}}"],
  "organization.web": ["{{organizacion_web}}", "{{business_web}}", "{{organization_web}}"],
  "contact.email": ["{{contacto_email}}", "{{contact_email}}"],
  "contact.firstName": ["{{contacto_nombre}}", "{{contact_name}}"],
  "contact.lastName": ["{{contacto_apellidos}}", "{{contact_last_name}}"],
  "contact.primaryPhone": ["{{contacto_tlf_principal}}", "{{contact_primary_phone}}"],
  "contact.secondaryPhone": ["{{contacto_tlf_secundario}}", "{{contact_secondary_phone}}"],
  "contact.appointment": ["{{contacto_cargo}}", "{{contact_appointment}}"],
  "contact.company": [
    "{{contacto_empresa}}",
    "{{contacto_organizacion}}",
    "{{contact_business_name}}",
    "{{contact_company}}",
  ],
  "contact.idNumber": ["{{contacto_nif}}", "{{contact_id_number}}"],
  "contact.addressLine1": ["{{contacto_direccion}}", "{{contact_address}}"],
  "contact.addressLine2": ["{{contacto_direccion_2}}", "{{contact_address_2}}"],
  "contact.zipOrPostalCode": ["{{contacto_cp}}", "{{contact_zip}}"],
  "contact.city": ["{{contacto_ciudad}}", "{{contacto_poblacion}}", "{{contact_city}}"],
  "contact.stateOrProvince": ["{{contacto_provincia}}", "{{contact_state}}", "{{contact_state_province}}"],
  "contact.country": ["{{contacto_pais}}", "{{contact_country}}"],
};

const generatePlaceholders = (quote, quoteVersion) => {
  return [
    //  Presupuesto
    {
      placeholders: placeholders["quote.description"],
      value: quote.description,
    },
    {
      placeholders: placeholders["quote.code"],
      value: quote.code,
    },
    {
      placeholders: placeholders["quote.date"],
      value: moment(quoteVersion.date).locale(quote.language).tz(quote.organization.settings.timezone).format("LL"),
    },
    {
      placeholders: placeholders["quote.expirationDate"],
      value: moment(quoteVersion.expirationDate)
        .locale(quote.language)
        .tz(quote.organization.settings.timezone)
        .format("LL"),
    },
    {
      placeholders: placeholders["quote.version.number"],
      value: quoteVersion.number,
    },

    // Organización
    {
      placeholders: placeholders["organization.name"],
      value: quote.organization.name,
    },
    {
      placeholders: placeholders["organization.addressLine1"],
      value: quote.organization.addressLine1 || "",
    },
    {
      placeholders: placeholders["organization.addressLine2"],
      value: quote.organization.addressLine2 || "",
    },
    {
      placeholders: placeholders["organization.stateOrProvince"],
      value: quote.organization.stateOrProvince || "",
    },
    {
      placeholders: placeholders["organization.city"],
      value: quote.organization.city || "",
    },
    {
      placeholders: placeholders["organization.country"],
      value: quote.organization.country ? trans(quote.language, quote.organization.country) : "",
    },
    {
      placeholders: placeholders["organization.zipOrPostalCode"],
      value: quote.organization.zipOrPostalCode || "",
    },
    {
      placeholders: placeholders["organization.web"],
      value: quote.organization.web || "",
    },

    //  Contacto
    {
      placeholders: placeholders["contact.email"],
      value: quote.contact.email || "",
    },
    {
      placeholders: placeholders["contact.firstName"],
      value: quote.contact.firstName,
    },
    {
      placeholders: placeholders["contact.lastName"],
      value: quote.contact.lastName || "",
    },
    {
      placeholders: placeholders["contact.primaryPhone"],
      value: quote.contact.primaryPhone || "",
    },
    {
      placeholders: placeholders["contact.secondaryPhone"],
      value: quote.contact.secondaryPhone || "",
    },
    {
      placeholders: placeholders["contact.appointment"],
      value: quote.contact.appointment || "",
    },
    {
      placeholders: placeholders["contact.company"],
      value: quote.contact.company || "",
    },
    {
      placeholders: placeholders["contact.idNumber"],
      value: quote.contact.nif || "",
    },
    {
      placeholders: placeholders["contact.addressLine1"],
      value: quote.contact.addressLine1 || "",
    },
    {
      placeholders: placeholders["contact.addressLine2"],
      value: quote.contact.addressLine2 || "",
    },
    {
      placeholders: placeholders["contact.zipOrPostalCode"],
      value: quote.contact.zipOrPostalCode || "",
    },
    {
      placeholders: placeholders["contact.city"],
      value: quote.contact.city || "",
    },
    {
      placeholders: placeholders["contact.stateOrProvince"],
      value: quote.contact.stateOrProvince || "",
    },
    {
      placeholders: placeholders["contact.country"],
      value: quote.contact.country ? trans(quote.language, quote.contact.country) : "",
    },
  ];
};

exports.generatePlaceholdersVars = (quote, quoteVersion, cleanDelimiters = true) => {
  return generatePlaceholders(quote, quoteVersion).reduce((acc, { placeholders, value }) => {
    placeholders.forEach((placeholder) => {
      const placeholderName = cleanDelimiters ? placeholder.replace("{{", "").replace("}}", "") : placeholder;
      acc[placeholderName] = value;
    });

    return acc;
  }, {});
};

exports.replacePlaceholders = (htmlString, quote, quoteVersion, escapeHtml = false, editorMode = false) => {
  if (!htmlString || htmlString.length === 0) return htmlString;

  const placeholdersVars = this.generatePlaceholdersVars(quote, quoteVersion, false);
  const placeholdersRegEx = new RegExp(Object.keys(placeholdersVars).join("|"), "g");

  return htmlString.replace(placeholdersRegEx, (matched) => {
    if (editorMode) {
      return `<span title="${
        placeholdersVars[matched] || "-"
      }" class="mceNonEditable custom-placeholder">${matched}</span>`;
    } else if (escapeHtml) {
      return escape(placeholdersVars[matched]);
    } else {
      return placeholdersVars[matched];
    }
  });
};

exports.replaceNotSupportedPlaceholders = (htmlString) => {
  if (!htmlString || htmlString.length === 0) return htmlString;

  const placeholdersArray = Object.keys(placeholders).reduce((accum, value) => accum.concat(placeholders[value]), []);

  return htmlString.replace(new RegExp("{{[^}]*}}", "gi"), (matched) => {
    return placeholdersArray.includes(matched) ? matched : "";
  });
};
